<template>
    <ac-modal :title="'Plan Discounts'" ref="modalRef">
        <template v-if="widgetReady">
            <div class="row form-group">
                <div class="info-board info-board-blue">
                    <template v-if="!readOnly">
                        <p>
                            To create a discount associated with this plan, add name, minimum and maximum number of members to be covered by the discount,
                            and the percentage to be discounted from the plan price. Discounts will apply immediately to all new and existing patients.
                            Please email <a href="mailto:support@accresa.com">support@accresa.com</a> to request the removal of a discount.
                        </p>
                    </template>
                    <template v-if="readOnly">
                        <p>
                            If an employee enrolls the minimum number of family members your discount requires into plans at a given clinic,
                            the discount will automatically be reflected during the last step of the employee's benefit selection confirmation.
                        </p>
                    </template>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <add-discounts :read-only="readOnly" :plan-id="planId" :discounts-passed="discounts" ref="addDiscounts"></add-discounts>
                </div>
                <div v-if="showIncompleteAlert && anyIncompleteRows" class="col-md-12">
                    <div class="alert alert-danger" style="margin-bottom: 0;">
                        There are some discounts that are not done being edited or added. 
                        Please finish making changes to continue and save all discounts.
                    </div>
                </div>
            </div>
        </template>
        <template slot="buttons">
            <ac-button v-if="!readOnly" class="btn btn-green btn-sm" style="float: left;" :action="addDiscount">
                ADD DISCOUNT
            </ac-button>
            <button v-if="!readOnly && !saveOnClose" class="btn btn-green btn-sm" href="#" @click.prevent="Validate">
                SAVE
            </button>
            <button v-if="saveOnClose" class="btn btn-green btn-sm" href="#" @click.prevent="Save">
                SAVE
            </button>
            <button class="btn btn-red btn-sm" @click.prevent="cancel">CANCEL</button>
        </template>
    </ac-modal>
</template>

<script>
    import {api} from "../../../../global/framework/api.js";
    import {mapGetters} from 'vuex';
    import _ from 'lodash';
    import Slider from 'bootstrap-slider';
    import AddDiscounts from "./AddDiscounts.vue";
    import {notifications} from "../../../../global/notifications.js";
    import {common} from "../../../../global/common.js";

    require('bootstrap-slider/dist/css/bootstrap-slider.min.css');

    export default {
        name: "PlanDiscountModal",
        components: {AddDiscounts},
        props: {
            planId: {type: [Number], required: false, default: 0},
            providerEntityId: {type: [Number], required: false, default: 0},
            readOnly: {type: [Boolean], required: false, default: false},
            saveOnClose: {type: [Boolean], required: false, default: false}
        },
        data() {
            return {
                widgetReady: false,
                discounts: [],
                showIncompleteAlert: false,
            }
        },
        computed: {
            anyIncompleteRows() {
                return this.$refs.addDiscounts.isRowBeingEdited || this.$refs.addDiscounts.addDiscountForm
            }
        },
        methods: {
            async showModal(discountPlanInfo) {
                this.discounts = discountPlanInfo.discounts;
                if (this.planId == 0 && discountPlanInfo.planId != 0) {
                    this.planId = discountPlanInfo.planId;
                }
                this.$refs.modalRef.open();
            },
            getDiscounts() {
                let allDiscounts = this.$refs.addDiscounts.getAllDiscounts();
                return allDiscounts;
            },
            getNewDiscounts() {
                let newDiscounts = this.$refs.addDiscounts.getNewDiscounts();
                return newDiscounts;
            },
            addDiscount() {
                this.$refs.addDiscounts.addDiscount();
            },
            async Save() {
                let self = this;

                if(this.anyIncompleteRows) {
                    this.showIncompleteAlert = true;
                    return;
                }

                let newDiscounts = self.getNewDiscounts();
                let result = await this.SaveDiscounts(newDiscounts);
                if (result) {
                    notifications.show({title: "Success!", message: result.msg}, common.ACRESSA_NOTIFICATIONS.SUCCESS);
                    self.$refs.modalRef.close();

                    if(result.data.planId != this.planId) {
                        window.location.href = `${window.location.pathname}#/${this.providerEntityId}/edit/plan/${result.data.planId}`;
                    }
                }
            },
            async SaveDiscounts(newDiscounts) {
                let data = await $.ajax({
                    url: `discount/${this.planId}/${this.providerEntityId}`,
                    contentType: 'application/json',
                    dataType: "json",
                    data: "[" + JSON.stringify(newDiscounts) + "]",
                    type: "POST"
                });
                return data;
            },
            async Validate() {
                let self = this;
                let newDiscounts = self.getNewDiscounts();
                let validationResult = await this.ValidateDiscounts(newDiscounts);
                if (validationResult) {
                    self.$refs.modalRef.close();
                    self.$bus.$emit(self.$bus.$AcEvents.DISCOUNT_ADDED, newDiscounts);
                }
            },
            async ValidateDiscounts(newDiscounts) {
                let strFinal = "[" + JSON.stringify(newDiscounts) + "]";
                let data = await $.ajax({
                    url: `discount/${this.planId}/ValidateDiscounts`,
                    contentType: 'application/json',
                    dataType: "json",
                    data: strFinal,
                    type: "POST"
                });
                return data
            },
            cancel() {
                this.$refs.modalRef.close();
            }
        },
        async mounted() {
            this.widgetReady = true;
        },
    }
</script>

<style scoped>
    .margin-bottom-30 {
        margin-bottom: 30px;
    }
</style>